import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import server from 'server/serverController2'
import { FooterStateActions } from 'store/actionCreators'

import AnimatedWindow from 'components/containers/common/AnimatedWindow'
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader'
import LottieLoader from 'components/containers/common/LottieLoader'

import UserReportBody from 'components/presenters/report/UserReportBody'

import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json'

export default function UserReportModal({
  userReportModalVisible,
  setUserReportModalVisible,
  userReportTargetNo,
  setUserReportTargetNo,
  handleBack = null,
  onUserReportComplete,
  hideUserFeed,
  zIndex,
}) {
  const [reasonList, setReasonList] = useState([])
  const [selectReason, setSelectReason] = useState(null)
  const [etcReason, setEtcReason] = useState(null)
  const [impostorReason, setImpostorReason] = useState(null)
  const [impostorFieldVisible, setImpostorFieldVisible] = useState(false)
  const [etcFieldVisible, setEtcFieldVisible] = useState(false)
  const [reportUser, setReportUser] = useState(null)

  const [valid, setValid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isEnd, setIsEnd] = useState(false)
  const [lottieOptions, setLottieOptions] = useState(null)

  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [isSubmitEnd, setIsSubmitEnd] = useState(false)

  useEffect(() => {
    return () => {
      FooterStateActions.updateFooterState({ visible: true })
    }
  }, [])

  const validateCheck = () => {
    if (!selectReason) {
      return false
    }
    if (selectReason?.name === 'impostor') {
      if (!impostorReason) {
        return false
      }
    }

    if (selectReason?.name === 'others') {
      if (!etcReason) {
        return false
      }
    }
    return true
  }

  const handleClose = () => {
    window.history.back()
    setUserReportModalVisible(false)
    setUserReportTargetNo(null)
    FooterStateActions.updateFooterState({ visible: true })
  }

  const handleSelectReasonChange = (reason) => {
    setSelectReason(reason)
  }

  const handleImpostorReasonChange = (e) => {
    setImpostorReason(e.target.value)
  }

  const handleEtcReasonChange = (e) => {
    setEtcReason(e.target.value)
  }

  const handleSubmit = async () => {
    try {
      const body = {}
      body['reason_no'] = selectReason.no
      if (selectReason.name === 'others') {
        body['reason'] = etcReason
      }
      if (selectReason.name === 'impostor') {
        body['reason'] = impostorReason
      }
      setIsSubmitLoading(true)
      setLottieOptions({
        loop: true,
        autoplay: true,
        renderer: 'svg',
        animationData: loadingAnimation,
      })
      const response = await server.postRequestData(`users/${userReportTargetNo}/reports`, body)

      if (response.success !== 1) {
        return
      }
      const jsonData = response.data
      const reportTargetUser = jsonData.inserted_item

      setIsSubmitLoading(false)
      setIsSubmitEnd(true)
      setReportUser(reportTargetUser)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSetReportReason = (res) => {
    try {
      if (res.success !== 1) {
        return
      }
      const jsonData = res.data
      const { reasons } = jsonData
      if (reasons.length > 0) {
        setReasonList([...reasonList, ...reasons])
        setIsEnd(false)
      } else {
        setIsEnd(true)
      }
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (isLoading && isEnd) return
    setIsLoading(true)
    server.getRequestData('reports/reasons?type=user', handleSetReportReason)
  }, [])

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setValid(validateCheck())
    if (selectReason?.name === 'others') {
      setEtcFieldVisible(true)
    } else {
      setEtcReason(null)
      setEtcFieldVisible(false)
    }

    if (selectReason?.name === 'impostor') {
      setImpostorFieldVisible(true)
    } else {
      setImpostorReason(null)
      setImpostorFieldVisible(false)
    }
  }, [selectReason, impostorReason, etcReason])

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(async () => {
    if (!isSubmitLoading && isSubmitEnd && reportUser) {
      if (hideUserFeed) {
        await hideUserFeed(reportUser.reported_user_data)
      }
      setIsSubmitLoading(false)
      setIsSubmitEnd(false)
      if (handleBack) {
        await handleBack()
      }
      await handleClose()
      await onUserReportComplete()
    }
  }, [reportUser])

  useEffect(() => {
    if (userReportModalVisible) {
      FooterStateActions.updateFooterState({ visible: false })
    }
  }, [userReportModalVisible])

  return (
    <AnimatedWindow
      zIndex={zIndex}
      windowOn={userReportModalVisible}
      setWindowOn={setUserReportModalVisible}
    >
      <div style={{ overflowY: 'scroll' }}>
        <AnimatedWindowHeader onBackBtn={handleClose} title={'유저 신고'} isCloseBtn={true} />
        <UserReportBody
          reasonList={reasonList}
          onSelectReasonChange={handleSelectReasonChange}
          onImpostorReasonChange={handleImpostorReasonChange}
          onEtcReasonChange={handleEtcReasonChange}
          onSubmit={handleSubmit}
          selectReason={selectReason}
          valid={valid}
          etcFieldVisible={etcFieldVisible}
          impostorFieldVisible={impostorFieldVisible}
        />
        {isSubmitLoading ? (
          lottieOptions ? (
            <LoadingAnimationBlock>
              <LottieLoader
                lottieOptions={lottieOptions}
                style={{ width: 'calc(100vw * (60 / 375))' }}
              />
            </LoadingAnimationBlock>
          ) : null
        ) : null}
      </div>
    </AnimatedWindow>
  )
}

const LoadingAnimationBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: ${(props) => (props?.zIndex ? props.zIndex : 500)};
`
